var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Any.js
// module id = 73
// module chunks = 0